export default function ParseDate(date) {
    date = date.split("T")[0].replaceAll("-", " ")
    return date.split(" ").join(".")
}